<template>
  <div class="skill">
    <p class="skill__title">
      {{ title }}
    </p>
    <k-progress :percent="value" :class="classname" :show-text="false" />
  </div>
</template>

<script>
export default {
  name: 'SkillItem',
  data: () => ({
    value: 0
  }),
  props: ['percent', 'title', 'timeout', 'theme', 'transition'],
  computed: {
    classname() {
      return this.theme + ' ' + this.transition;
    }
  },
  mounted() {
    setTimeout(() => {
      this.value = 100;
    }, this.timeout);
  }
};
</script>

<style lang="scss">
@import '@/scss/_variables';

.skill {
  margin-bottom: 10px;
  &__title {
    margin-bottom: 5px;
    font-weight: 600;
    font-size: 14px;
  }
}
.k-progress {
  transition: 0.5s all ease-in;
  &.orange {
    .k-progress-outer-line {
      background: $c-orange;
    }
  }
  &.blue {
    .k-progress-outer-line {
      background: $c-blue;
    }
  }
  &.yellow {
    .k-progress-outer-line {
      background: $c-yellow;
    }
  }
  &.sky-blue {
    .k-progress-outer-line {
      background: $c-sky-blue;
    }
  }
  &.turquoise {
    .k-progress-outer-line {
      background: $c-turquoise;
    }
  }
  &.green {
    .k-progress-outer-line {
      background: $c-green;
    }
  }
  &.red {
    .k-progress-outer-line {
      background: $c-red;
    }
  }
  &.dark-blue {
    .k-progress-outer-line {
      background: $c-dark-blue;
    }
  }
}
</style>
